export enum YesOrNo {
  Yes = 'Y',
  No = 'N'
}